import { render } from "./GroupSettings.vue?vue&type=template&id=89e9ba7a&scoped=true"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"

import "./GroupSettings.vue?vue&type=style&index=0&id=89e9ba7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e9ba7a"]])

export default __exports__